import JobsList from './JobsList';

export default JobsList;
